// Generated by CoffeeScript 1.12.7

